
import React from 'react'
import { connect } from "react-redux"
import { Link } from 'react-router'
import { fetchPractices } from "../../actions/index"
import { setTitle } from "../../actions/index"
import sortBy from 'lodash/sortBy'
import PracticeSearch from "../practice/PracticeSearch"

import loaderImg from '../practice_admin/images/loader.gif'

@connect((store) => {
	return {
		User: store.User.User,
		practices: store.practices,
		app: store.app,
		practice_types: store.practice_types
	}
})
class AdminPractices extends React.Component {

	constructor(props) {
		super(props);

		this.state = { 
			'value': 'name',
			'loading': true,
			professionSelection: "5e673f588be36a0015b15299"
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleProfessionChange = this.handleProfessionChange.bind(this);
		this.setUp = this.setUp.bind(this);
	}

	componentDidUpdate(nextProps) {
		if (this.props.User.token && this.props.User.name != nextProps.User.name) {
			this.setUp();
		}
	}

	componentDidMount() {
		this.setUp();
	}

	setUp() {
		if (this.props.User.token && this.props.User.name != '') {
			this.props.dispatch(setTitle('Admin: Practices'));
			this.props.dispatch(fetchPractices())
				.then(practices => {
					this.setState({ 'loading': false });
				});
		}
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
	}

	handleProfessionChange(e) {
		this.setState({ professionSelection: e.target.value });
	}

	render() {
		let {
			loading
		} = this.state;

		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

		// console.log(this.props.practices.therapists.length)
		return (
			<main className="main adminPracticesView">
				<div ref="page" >
					<PracticeSearch admin={true}/>

					<div className="filterRow">
						Status:<select value={this.state.value} onChange={this.handleChange}>
							<option value="">All</option>
							<option value="pending">Pending</option>
						</select>

						Sort By:<select value={this.state.value} onChange={this.handleChange}>
							<option value="">All</option>
							<option value="name">Name</option>
							<option value="date">Date</option>
						</select>
					</div>
					<div className="select mb2">
						Profession:
        				<select
							value={this.state.professionSelection}
						  	onChange={e => this.handleProfessionChange(e)}
						>
							{(this.props.practice_types && this.props.practice_types.length) ? this.props.practice_types.map(type => (
								<option key={type.id} value={type.id}>
									{type.practice_type}
								</option>
							)): ''}
						</select>
					</div>

					<div className="page mb8">
						<ul className="md-list wide height100">
							{(this.props.practices && this.props.practices.length) ? sortBy(this.props.practices, [this.state.value])
							.filter(practice => {
								return practice.practice_type == this.state.professionSelection
							})
							.map(practice => (
								<li key={practice._id}>
									<Link to={`/admin/practices/${practice._id}`}>{practice.name}</Link>  ({practice.therapists.length})<br />
									<small><Link to={`/admin/practices/${practice._id}`}>{`/admin/practices/${practice._id}`}</Link></small>
								</li>
							)
							):''}
						</ul>
					</div>
				</div>
			</main>
		)
	}
}

export default AdminPractices;



// WEBPACK FOOTER //
// ./src/components/admin/AdminPractices.jsx